import { EllipseOutline } from 'themes/organic/components';
import { ContentContainer } from 'themes/organic/components/ContentContainer';

import { useAboutPage } from 'hooks/page/about/useAboutPage';

import { OrganicAboutSection } from './components/OrganicAboutSection';
import { OrganicBusinessHoursSection } from './components/OrganicBusinessHoursSection';
import { OrganicCancellationPolicySection } from './components/OrganicCancellationPolicySection/OrganicCancellationPolicySection';
import { OrganicReviewList } from './components/OrganicReviewList';
import { TeamSection } from './components/TeamSection/TeamSection';

import s from './OrganicAbout.module.css';

export const OrganicAbout = () => {
  const {
    aboutText,
    professionals,
    hasCancellationPolicy,
    cancellationPolicyText,
    showReviews,
    showTeam,
    handleBook,
  } = useAboutPage();

  return (
    <>
      <ContentContainer className={s.ellipseContainer}>
        <EllipseOutline className={s.ellipse} />
      </ContentContainer>
      <OrganicAboutSection about={aboutText} />
      <OrganicBusinessHoursSection />
      {hasCancellationPolicy && (
        <OrganicCancellationPolicySection
          cancellationPolicy={cancellationPolicyText}
        />
      )}
      {showTeam && (
        <TeamSection professionals={professionals} onProClick={handleBook} />
      )}
      {showReviews && <OrganicReviewList />}
    </>
  );
};
